import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { IChartGroups } from "utils/interfaces/report";
import React from "react";
import { GRAPH_TYPE_CATEGORY_TABLE_HEADING } from "utils/constants/report";
import { GraphType } from "utils/enums/graph";

interface IGraphReportTableProps {
  data: IChartGroups[];
  percentageData: IChartGroups[];
  optionList: string[];
  graphType: GraphType;
  colorValueMap: Record<string, string>;
}

const GraphReportTable: React.FC<IGraphReportTableProps> = (props) => {
  const { data, optionList, graphType, percentageData, colorValueMap } = props;
  const groups = data.map((d) => d.groupName);

  return (
    <TableContainer style={{ marginTop: "16px" }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell
              align="left"
              sx={{
                width: "232px",
                minWidth: "232px",
              }}
            >
              {GRAPH_TYPE_CATEGORY_TABLE_HEADING[graphType]}
            </TableCell>
            {groups.map((group) => (
              <TableCell
                key={`${group}`}
                align="center"
                sx={{ width: "150px", minWidth: "100px" }}
              >
                {`${group} (%)`}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {optionList.map((category) => (
            <TableRow key={`${category}-graph-row-${graphType}`}>
              <TableCell
                style={{ display: "flex", alignItems: "center", gap: 6 }}
              >
                <div
                  style={{
                    width: 10,
                    height: 10,
                    backgroundColor: colorValueMap[category],
                    borderRadius: 2,
                  }}
                />
                <span>{category}</span>
              </TableCell>
              {data.map((groupData, index) => {
                const count = groupData[category] ?? 0;
                const percentage = percentageData[index]?.[category] ?? 0;

                return (
                  <TableCell
                    align="center"
                    key={`${category}-${groupData.groupName}-count-percentage`}
                  >
                    {count} ({percentage}%)
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default GraphReportTable;
